import { Zap, PhoneIncoming, TrendingUp, Instagram, RefreshCcw, CalendarClock, Star } from 'lucide-react';

export const PLAYS = [
  {
    id: 'speed-to-lead', icon: Zap, title: 'Speed to Lead', tagline: 'Call new leads within 60 seconds.',
    channels: ['Outbound voice', 'SMS'],
    flow: ['A form or ad lead lands in GHL', 'AI calls in under 60 seconds and qualifies', 'Booked on the calendar, confirmation texted'],
    script: [
      { who: 'system', text: 'New lead · Facebook ad · just now' },
      { who: 'agent', voice: true, text: 'Hi Maria, it’s Ava from Bright Smile Dental — you just asked about whitening. Got a minute?' },
      { who: 'lead', text: 'Yes! Anything open this week?' },
      { who: 'agent', voice: true, text: 'Thursday at 4:30 is free. Want me to lock it in?' },
      { who: 'lead', text: 'Perfect.' },
    ],
    result: 'Booked · Thu 4:30 PM · Confirmation text sent',
  },
  {
    id: 'ai-receptionist', icon: PhoneIncoming, title: 'AI Receptionist', tagline: 'Every call answered. Nights and weekends too.',
    channels: ['Inbound voice', 'Web chat'],
    flow: ['A customer calls the business line', 'AI answers questions and checks availability', 'Booked — or urgent calls transferred to the team'],
    script: [
      { who: 'system', text: 'Incoming call · 9:47 PM' },
      { who: 'lead', text: 'Hi, my AC stopped working. Can someone come tomorrow?' },
      { who: 'agent', voice: true, text: 'Sorry to hear that! I have 8 AM or 1 PM tomorrow. Which works?' },
      { who: 'lead', text: '8 AM, please.' },
      { who: 'agent', voice: true, text: 'Done. I’ll text you the details now.' },
    ],
    result: 'Service call booked · Tomorrow 8:00 AM',
  },
  {
    id: 'sales-agent', icon: TrendingUp, title: 'Sales Agent', tagline: 'Upsell low-ticket offers to existing customers.',
    channels: ['Outbound voice', 'SMS'],
    flow: ['Past customers tagged in GHL', 'AI calls with a personal offer', 'Offer accepted, payment link texted'],
    script: [
      { who: 'system', text: 'Campaign · Past customers · Gutter clean $99' },
      { who: 'agent', voice: true, text: 'Hi Dan, it’s Leo from Peak Roofing. Since we did your roof last spring, gutter cleaning is $99 this month. Interested?' },
      { who: 'lead', text: 'Actually, yes. Before the rain would be great.' },
      { who: 'agent', voice: true, text: 'Great — I’ll text you a link to pick your day.' },
    ],
    result: 'Upsell accepted · Link sent by SMS',
  },
  {
    id: 'dm-setter', icon: Instagram, title: 'DM Setter', tagline: 'Turn DMs and comments into booked calls.',
    channels: ['Instagram DM', 'Messenger'],
    flow: ['Someone DMs or comments on a post', 'AI replies in seconds and qualifies', 'A call is booked right in the DM'],
    script: [
      { who: 'system', text: 'Instagram DM · @fit.with.jess' },
      { who: 'lead', text: 'How much is the 12-week program?' },
      { who: 'agent', text: 'Hey Jess! Depends on your goal — strength or weight loss?' },
      { who: 'lead', text: 'Weight loss, about 20 lbs.' },
      { who: 'agent', text: 'Love it. Coach Mike has a free 15-min call Wed at 6. Want it?' },
      { who: 'lead', text: 'Yes please!' },
    ],
    result: 'Call booked · Wed 6:00 PM',
  },
  {
    id: 'reactivation', icon: RefreshCcw, title: 'Database Reactivation', tagline: 'Wake up old leads already in the CRM.',
    channels: ['SMS', 'Outbound voice'],
    flow: ['Old leads selected in GHL', 'AI texts first, calls when they reply', 'Revived leads booked'],
    script: [
      { who: 'system', text: 'Reactivation · Leads inactive 6+ months' },
      { who: 'agent', text: 'Hi Chris, it’s Tara from Lakeview Realty. Still thinking about selling this year?' },
      { who: 'lead', text: 'Maybe. What’s my place worth?' },
      { who: 'agent', text: 'Happy to find out. Can I call you for 2 minutes now?' },
      { who: 'lead', text: 'Sure.' },
    ],
    result: 'Reply → call → valuation booked',
  },
  {
    id: 'reminders', icon: CalendarClock, title: 'Reminders & No-Show Recovery', tagline: 'Fewer empty slots on the calendar.',
    channels: ['SMS', 'WhatsApp', 'Outbound voice'],
    flow: ['An appointment is coming up — or missed', 'AI reminds, confirms or rebooks', 'Confirmed or rescheduled'],
    script: [
      { who: 'system', text: 'Missed appointment · 2:00 PM' },
      { who: 'agent', text: 'Hi Sam, we missed you at 2 today. Want to grab another time?' },
      { who: 'lead', text: 'Sorry! Friday morning?' },
      { who: 'agent', text: 'Friday 9:30 is free — booked it for you.' },
    ],
    result: 'Rescheduled · Fri 9:30 AM',
  },
  {
    id: 'reviews', icon: Star, title: 'Reviews & Referrals', tagline: 'More 5-star reviews. More referrals.',
    channels: ['SMS', 'WhatsApp'],
    flow: ['A job is marked complete', 'AI checks in and asks for a review', 'Review left, referral offer sent'],
    script: [
      { who: 'system', text: 'Job complete · Kitchen remodel' },
      { who: 'agent', text: 'Hi Ana, how does the new kitchen feel?' },
      { who: 'lead', text: 'We love it!' },
      { who: 'agent', text: 'So glad! Would you leave a quick Google review? Here’s the link.' },
      { who: 'lead', text: 'Done — 5 stars!' },
    ],
    result: 'Review left · Referral offer sent',
  },
];
